import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommunicationLogComponent } from './communication-log/communication-log.component';
import { MailTemplatesPopupComponent } from './mail-templates/mail-templates-popup.component';
import { PreviewMailPopupComponent } from './preview-mail-popup/preview-mail-popup.component';
import { CommunicationLogDetailModalComponent, SafeHtmlPipe } from './communication-log-detail-modal/communication-log-detail-modal.component';
import { SearchDropDownModule } from '../shared/search-dropdown/search-dropdown.module';
import { SearchBoxModule } from '../shared/search-box/search-box.module';

@NgModule({
  declarations: [
    MailTemplatesPopupComponent,
    PreviewMailPopupComponent,
    CommunicationLogComponent,
    CommunicationLogDetailModalComponent,SafeHtmlPipe
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    InfiniteScrollModule,
    MatTableModule,
    MatSortModule,
    SearchDropDownModule,
    SearchBoxModule
  ],
})
export class MailModule {}
